import { AnalyticsApplicationData } from './piano-analytics.types';

export const eventButtonClick = 'button click';
export const applicationId = 'logon-and-signing';
export const pageViewEventName = 'application.display';
export const clickEventName = 'click.action';
export const eventSuccess = 'success';
export const eventFailure = 'failure';

export const APP_DATA: AnalyticsApplicationData = {
  application_id: applicationId,
  application_mode: 'new',
  application_process: 'stp',
  application_segment: 'consumer',
  application_version: 3,
  application_category: 'app-activation',
};
